import { ImportCatalogState } from './state';
import { importCatalogInitialState } from './initial-state';
import { ImportCatalogActions } from './action-creators';
import * as actions from './actions';

export const importCatalogReducer = (
  state: ImportCatalogState = importCatalogInitialState,
  action: ImportCatalogActions
): ImportCatalogState => {
  switch (action.type) {
    case actions.START_IMPORT_CATALOG: {
      return {
        ...state,
        inProgress: true,
        progress: 0,
      };
    }

    case actions.IMPORT_CATALOG_SUCCESS: {
      return {
        ...state,
        inProgress: false,
      };
    }

    case actions.TRACK_IMPORT_PROGRESS_SUCCESS: {
      return {
        ...state,
        inProgress: action.progress !== 100,
        progress: action.progress,
      };
    }

    default:
      return state;
  }
};
